import React, { useEffect, useState } from 'react'; 
import FormModal from '../../Utils/FormModal';
import { useNavigate, useParams } from 'react-router-dom';
import { getFromAPI , postToAPI , putToAPI , deleteFromAPI, sendNotification,formatDate } from "../../Utils/utils";
import { toast } from "react-toastify";
import { Navigate, useLocation } from "react-router-dom";

export default function LeaveApproval({leaveId, leaveApprovalModalShow, handleFormModalClose}) {
    const [leaveidData, setleaveidData] = useState([]);
    const navigate = useNavigate();
   // const [token, set_Token] = useState([]);
    const [showButtons, setShowButtons] = useState(true);
    const useEmail = localStorage.getItem('email');
    const [previous_token, setPrevious_token] = useState([]);
    const [FinalReporting_to_Email,setFinalReporting_to_Email] = useState();
    const [supervisor_name,setSupervisor_name] = useState();
    const [finalReportingToPerson,setFinalReportingPerson] = useState();
    const [reportToPerson,setReportToPerson] = useState();
    const [reportToId,setReportToId] = useState(0);
    const [finalReportingToId,setFinalReportingToId] = useState(0);
    const staffId = Number(localStorage.getItem('loggedInStaffId'));
    const loginPosition = localStorage.getItem('designation')?.toLowerCase();
    const { id,token } = useParams();
    if (id) {
        leaveApprovalModalShow = true;
    }

    // Get leave data from leave id
    const initialLockerData = {
        leaveEmployeeName: '',
        leaveEmployeeId: '',
        leaveType: '',
        leaveDes: '',
        leave_start_date: '',
        leave_end_date: '',
        leave_part_selection: '',
        leave_rejection_reason: '',
        leave_description: '',
        leave_total_days: '',
        leave_balance : '',
        FinalReporting_to : '',
        finalReporting_to_Email : '',
        FinalReporting_to : '',
        final_reportTo_name : '',
        report_to_id : '',
        final_report_to_id : '',

    };

    // input value
    const [data, setData] = useState(initialLockerData);
    const authorizedRoles = ['admin', 'director', 'ceo'];
    // Add/Edit modal
    const location = useLocation();
    const UrlsParams = new URLSearchParams(location.search);
    const [reportingToId, setReportingToId] = useState(null); // State to store reportingToId
    const [reportToEmail, setReportToEmail] = useState("");
    const [leaveStatus, setLeaveStatus] = useState(''); // Track leave status

    useEffect(() => {
        // Check if both tokens exist and are the same
        if (token && previous_token && token === previous_token) {
            setShowButtons(true);
        } else {
            setShowButtons(false);
        }
    }, [token, previous_token]);

    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const response = await getFromAPI(`leave_data/?staffid=${staffId}`);
                
                // Check if response and necessary fields are available
                if (response?.staff_admin_data?.staffid) {
                    setReportingToId(response.staff_admin_data.staffid); // Set the reporting ID
                    setReportToEmail(response.staff_admin_data.email); // Set the reporting
                    setFinalReporting_to_Email(response.super_admin_data.email)
                    setSupervisor_name(response.super_admin_data.firstname)
                    setReportToId(response.staff_admin_data.staffid); //adjusted
                    setFinalReportingToId(response.super_admin_data.staffid)

                } 
            } catch (error) {
                console.error('Error fetching staff:', error);            }
        };

        fetchStaff();
    }, [staffId]);

    const handleInputChange = (index, field, value) => {
        setData({ ...data, [field]: value });
    };
    const handleSubmit = (e) => {
        
        e.preventDefault();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const endpoint = id ? `FtsLeave/?id=${id}` : `FtsLeave/?id=${leaveId}`;
                const response = await getFromAPI(endpoint);
    
                if (!response || response.length === 0 || Object.values(response[0]).every(value => value === "" || value === null || value === undefined)) {
                    toast.error("Leave is not found or deleted");
                    return;
                }
    
                setLeaveStatus(response[0].leave_status);
                setFinalReportingPerson(response[0].finalReporting_to_Email);
                setReportToPerson(response[0].leave_report_to_email);
    
                setleaveidData(response[0]); // Set the first object from the response array
                setData({
                    leaveEmployeeName: response[0].leave_employee_name,
                    leaveEmployeeId: id,
                    leaveType: response[0].leave_type,
                    leaveDes: response[0].leave_description,
                    leave_start_date: response[0].leave_start_date,
                    leave_end_date: response[0].leave_end_date,
                    leave_part_selection: response[0].leave_part_selection,
                    leave_rejection_reason: response[0].leave_rejection_reason,
                    leave_total_days: response[0].leave_total_days,
                    leave_total_hours: response[0].leave_total_hours,
                    leave_token: response[0].leave_token,
                    leave_balance: response[0].leave_balance,
                    leave_status: response[0].leave_status,
                    finalReporting_to_Email: response[0].finalReporting_to_Email,
                    FinalReporting_to: response[0].FinalReporting_to,
                    final_report_to_id: response[0].final_report_to_id,
                    report_to_id: response[0].report_to_id,
                    created_user_id: response[0].created_user_id
                });
                
    
                setPrevious_token(response[0].leave_token);
    
            } catch (error) {
                console.error('Error fetching staff:', error);
            }
        };
    
        fetchData();
    }, [leaveId]);
    

    const leaveTableHeader = [
        'Start Date', 'Leave Type', 'Total Hours/Days',
    ];
    
const calculateLeaveRowData = () => {
    const leaveRowData = [];
    const startDate = new Date(data.leave_start_date);
    const endDate = new Date(data.leave_end_date);

    let leavePartSelection = data.leave_part_selection;

    // Parse if it's a string
    if (typeof leavePartSelection === 'string' && leavePartSelection.trim()) {
        try {
            leavePartSelection = JSON.parse(
                leavePartSelection.replace(/None/g, 'null').replace(/'/g, '"')
            );
        } catch (e) {
            leavePartSelection = [];
        }
    }

    // Ensure it's an array
    const leaveTypes = Array.isArray(leavePartSelection) ? leavePartSelection : [];

    if (startDate && endDate && startDate <= endDate) {
        let currentDate = new Date(startDate);
        let index = 0;

        while (currentDate <= endDate) {
            // Pick type for this day (or fallback to Full Day)
            let currentLeaveType = leaveTypes[index] || "Full Day";

            let leaveType = "";
            let totalHours = "";

            const type = currentLeaveType.trim().toLowerCase();

            if (type === "full day" || type === "none") {
                leaveType = "Full Day";
                totalHours = "8 Hours";
            } else if (type === "first half") {
                leaveType = "First Half";
                totalHours = "4 Hours";
            } else if (type === "second half") {
                leaveType = "Second Half";
                totalHours = "4 Hours";
            } else if (type === "weekend") {
                leaveType = "Weekend";
                totalHours = "0 Hours";
            } else if (type === "holiday") {
                leaveType = "Holiday";
                totalHours = "0 Hours";
            }

            leaveRowData.push({
                startDate: formatDate(currentDate.toISOString().split("T")[0]),
                leaveType,
                totalHours,
            });

            // Next day
            currentDate.setDate(currentDate.getDate() + 1);
            index++;
        }
    }

    return leaveRowData;
 };
const handleApproval = async (status) => {
    try {
        // Validate rejection reason for Rejected status
        if ((status === "Rejected" || status === "Approved") && !data.leave_rejection_reason.trim()) {
            toast.error("Please enter a comment before approving/rejecting the leave.");
            return;
        }
            
        // Validate leave request
        if (!data.leaveEmployeeId) {
            toast.error('Invalid leave request.');
            return;
        }

        // Check if user is authorized (Admin, Director, CEO)
        const isAuthorized = authorizedRoles.includes(loginPosition);
        let newStatus = status;
        // Handle status transitions based on user role and current status
        if (isAuthorized) {
            // Admin, Director, CEO can approve/reject directly
            newStatus = status;
        } else {
            // Non-authorized users follow the standard approval flow
            if (data.leave_status === 'Pending' && staffId === data.report_to_id) {
                newStatus = status === 'Approved' ? 'Partially Approved' : 'Rejected';
            } else if ((data.leave_status === 'Pending' || data.leave_status === 'Partially Approved') && staffId === data.final_report_to_id) {
                newStatus = status;
            } else {
                toast.error('You are not authorized to perform this action.');
                return;
            }
        }

        // Prepare updated data for API
        const updatedData = {
            ...data,
            leave_status: newStatus,
            leave_rejection_reason: (status === 'Rejected'  ||status == 'Approved')? data.leave_rejection_reason : '',
        };

        // Update leave status via API
        const response = await putToAPI(`FtsLeave/${data.leaveEmployeeId}/`, updatedData);
        if (!response) {
            throw new Error('API response was unsuccessful');
        }

        // Show success notification
        toast.success(`Leave ${newStatus.toLowerCase()} successfully!`);

        // Close modal and hide buttons
        handelCloseLeaveDataModal();
        setShowButtons(false);
    } catch (error) {
        console.error(`Error ${status.toLowerCase()} leave:`, error);
        toast.error(`Failed to ${status.toLowerCase()} leave. Please try again.`);
    }
};
    // Call this method to get the leave row data
    const leaveTableRowData = calculateLeaveRowData();
        
    // This method is used to close the leave data modal
    const handelCloseLeaveDataModal = () => {
        navigate('/leave');
    };
    
        
    const rows = [
        {
            columns: [
                { size: { lg: 12 }, label: 'Employee Name', type: 'text', name: 'leaveEmployeeName', id: 'leaveEmployeeName', placeholder: 'Enter title...', value: data.leaveEmployeeName, errormsg: '', disabled: true },
                { size: { lg: 6 }, label: 'Employee ID', type: 'text', name: 'leaveEmployeeID', id: 'leaveEmployeeID', placeholder: 'Enter title...', value: id, errormsg: '', disabled: true },
                { size: { lg: 6 }, label: 'Leave Type', type: 'text', name: 'leaveType', id: 'leaveType', placeholder: 'Enter title...', value: data.leaveType, errormsg: '', disabled: true },
                { type: 'table', tableSize: 'md', thead: leaveTableHeader, tbodydata: leaveTableRowData, },
                { size: { md: 12 }, label: 'Leave Description', type: 'textarea', name: 'leaveDes', formrow: '3', id: 'leaveDes', placeholder: 'Enter message...', value: data.leaveDes, errormsg: '', disabled: true },
                { size: { md: 12 }, label: 'Comment', type: 'text', name : 'leave_rejection_reason', formrow: '3', id: 'leave_rejection_reason', placeholder: 'Enter Comment...',value : data.leave_rejection_reason,errormsg: ''},
                {
                    size: { sm: 6, lg: 4 },
                    label: 'Leave Balance',
                    type: 'text',
                    name: 'leaveBalance',
                    id: 'leaveBalance',
                    placeholder: 'Leave Balance',
                    value: data.leave_balance, // Dynamically update this value based on selected leave type
                    readOnly: true, // Make this field read-only
                    disabled: true,
                },
            ]
        }
    ];

    const Buttons = (leaveStatus === "Pending") ? [
        { 
            variant: "primary", 
            text: "Approved", 
            onClick: () => handleApproval("Approved"),
        },
        { 
            variant: "secondary", 
            text: "Rejected", 
            onClick: () => handleApproval("Rejected"),
        }
    ] : (leaveStatus === "Partially Approved") ? [
        { 
            variant: "primary", 
            text: "Approved", 
            onClick: () => {
                if (staffId === data.final_report_to_id || authorizedRoles.includes(loginPosition)) {
                    handleApproval("Approved");
                } else {
                    toast.error("Only final reporting manager or authorized users can approve fully.");
                }
            },
        },
        { 
            variant: "secondary", 
            text: "Rejected", 
            onClick: () => {
                if (staffId === data.final_report_to_id || authorizedRoles.includes(loginPosition)) {
                    handleApproval("Rejected");
                } else {
                    toast.error("Only final reporting manager or authorized users can reject.");
                }
            },
        }
    ] : [];
    

    return (
        <>
            {/* From Modal */}
            <FormModal title="Leave Details" modalSize="lg" formModalShow={leaveApprovalModalShow} Buttons={Buttons} handleFormModalClose={id ? handelCloseLeaveDataModal : handleFormModalClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>
    );
}
